// src/backendServices/broadcastingManagment/api_subtitles.ts

import axios from 'axios';
import { getApiUrl } from '../urls';

/**
 * Sous-titres en direct du flux final (2026-10-15) : transcription par Google
 * dans le microservice de la chaîne, pistes WebVTT proposées aux spectateurs du
 * portail et de l'Apple TV. admin-api, BroadcastingChannelSubtitles.
 *
 * Route API Platform : `Accept: application/ld+json`, sinon 406.
 */

export interface SubtitleLanguageChoice {
  /** Code Google de la langue parlée, ex. « fr-FR ». */
  language : string;
  label    : string;
}

export interface SubtitlesState {
  enabled     : boolean;
  language    : string;
  /** Langue de la traduction proposée en plus (« en », ou « fr » pour un direct en anglais). */
  translation : string;
  languages   : SubtitleLanguageChoice[];
  /** true : pris par le microservice ; false : chaîne allumée mais microservice muet ; null : chaîne éteinte. */
  applied     : boolean | null;
  error       : string | null;
}

const url = (id: number) => getApiUrl(`/api/broadcasting_channels/${id}/subtitles`);

const headers = {
  'Accept'       : 'application/ld+json',
  'Content-Type' : 'application/json',
};

export const fetchSubtitles = async (channelId: number): Promise<SubtitlesState> => {
  const response = await axios.get(url(channelId), { headers });
  return response.data as SubtitlesState;
};

export const updateSubtitles = async (
  channelId : number,
  enabled   : boolean,
  language ?: string,
): Promise<SubtitlesState> => {
  const response = await axios.patch(url(channelId), { enabled, ...(language ? { language } : {}) }, { headers });
  return response.data as SubtitlesState;
};
